import { computed, type Ref } from 'vue';
import { useStore } from 'vuex';

interface TagSettings {
    name: string;
    isDangerous?: boolean;
}

type Content = Record<string, any>;

export function useMainPageSlice(contentRef: Ref<Content | null>) {
    const store = useStore();

    const promotions = computed(() => store.state.promotions?.data || []);

    const settings = computed(() => contentRef.value?.settings || contentRef.value || {});

    const isAvailable = computed(() => {
        if (!settings.value.available) return true;
        return settings.value.available.includes(contentRef.value?.tabActive);
    });

    const classNameSection = computed(() => ({
        'has-border-top': settings.value.hasBorderTop,
        'has-background': settings.value.hasBackground,
    }));

    function tag(tagSettings: TagSettings, item?: Content) {
        const content = item || contentRef.value || {};

        return {
            className: tagSettings.name,
            isDangerous: tagSettings.isDangerous,
            titleTag: content[`${tagSettings.name}Tag`],
            title: content[tagSettings.name] || content.label || '',
        };
    }

    function promotionActive(productID: number | string) {
        if (!productID) return {};

        return promotions.value
            .filter((item: any) => !item.is_for_emails_only)
            .find((item: any) => item.product_id === productID) || {};
    }

    return {
        promotions,
        settings,
        isAvailable,
        classNameSection,
        tag,
        promotionActive,
    };
}
